export enum MapToolbarWidgetItems {
  UnassignedPickups = 'unassignedPickups',
  UnassignedDeliveries = 'unassignedDeliveries',
  DriversLocation = 'driversLocation',
  Traffic = 'traffic',
  GeoAreas = 'geoAreas',
  CompletedStops = 'completedStops',
  Weather = 'weather',
}
